import React, { useCallback, useState } from 'react'
import cx from 'classnames'
import { Helmet } from 'react-helmet'
import { Layout, LayoutBody, LayoutContent, LayoutProvider, TableProvider } from '../../../views/components'
import AdminBillingContent from './AdminBillingContent'
import AdminBillingPanel, { PanelMode } from './AdminBillingPanel'
import { DiscountTarget } from './DiscountPanel/DiscountPanel'
import { AgencyOption } from './AddAgencyPanel/AddAgencyPanel'
import styles from './AdminBillingPage.module.scss'

// Panel state is local, not LayoutProvider's secondaryPanel: Layout/Content
// adds marginLeft equal to that panel's width, which would leave a gap.
const AdminBillingPage = () => {
  const [mode, setMode] = useState<PanelMode>(null)

  const closePanel = useCallback(() => setMode(null), [])
  const openCounter = useCallback(() => setMode({ kind: 'counter' }), [])
  const openAdd = useCallback(() => setMode({ kind: 'add' }), [])
  const openDiscounts = useCallback((target: DiscountTarget) => setMode({ kind: 'discounts', target }), [])

  // Picking an agency swaps the drawer straight to its discount form.
  const onPickAgency = useCallback(
    (agency: AgencyOption) =>
      setMode({
        kind: 'discounts',
        target: { agencyId: agency.agencyId, agencyName: agency.agencyName, tradingAs: agency.tradingAs },
      }),
    [],
  )

  return (
    <div className={cx(styles.root, { [styles['with-panel']]: !!mode })}>
      <LayoutProvider
        stateKey="adminBilling"
        initialProps={{
          sidebar: { open: false, width: 0 },
          primaryPanel: { open: false, width: 0 },
          secondaryPanel: { open: false, width: 0 },
        }}
      >
        <Helmet>
          <title>reOS | Billing</title>
        </Helmet>
        <Layout>
          <LayoutBody>
            <LayoutContent>
              <TableProvider>
                <AdminBillingContent
                  onEditCounter={openCounter}
                  onAddAgency={openAdd}
                  onEditDiscounts={openDiscounts}
                />
              </TableProvider>
            </LayoutContent>
          </LayoutBody>
        </Layout>
        {/* Fixed right-hand drawer, so it sits outside LayoutBody's flex row. */}
        <AdminBillingPanel mode={mode} onClose={closePanel} onPickAgency={onPickAgency} />
      </LayoutProvider>
    </div>
  )
}

export default AdminBillingPage
